import { Construction } from 'lucide-react';

export interface PendingTabProps {
  title: string;
  description: string;
}

/**
 * Placeholder for Team Member detail tabs whose backend is still being built
 * under follow-up child issues (Documents/Drive, per-person Meeting Notes,
 * per-user Calendar). Keeps the tab layout uniform while the data layer lands.
 */
export function PendingTab({ title, description }: PendingTabProps) {
  return (
    <div className="rounded-lg border border-dashed border-gray-300 bg-white p-8 text-center shadow-sm">
      <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-gray-100 text-gray-400">
        <Construction size={22} />
      </div>
      <h3 className="text-sm font-semibold text-gray-900">{title}</h3>
      <p className="mx-auto mt-1 max-w-md text-sm text-gray-500">{description}</p>
    </div>
  );
}
